import { Injectable } from '@angular/core';
import { DoctorCorrespondenceEndPoints } from 'src/app/constants/api-endpoints';
import { DoctorCorrespondence } from 'src/app/models/doctor/doctor-correspondence.model';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiService } from 'src/app/sections/common/services/api.service';

@Injectable({
  providedIn: 'root'
})
export class DoctorCorrespondenceService {

  doctorCorrespondenceUrl = DoctorCorrespondenceEndPoints;

  constructor(private _apiService : ApiService) { }

  private returnResponse(response){
    if (response._statusCode > 399) {
      throw (response);
    }
    return response;
  }

  getDoctorCorrespondenceByDoctorId(id: number): Observable<DoctorCorrespondence> {
    return this._apiService.get(this.doctorCorrespondenceUrl.getDoctorCorrespondenceByDoctorId + id, true).pipe(
        map((response: any) => {
        return this.returnResponse(response);
      }));
  }

  getDoctorCorrespondenceById(id: number): Observable<DoctorCorrespondence> {
    return this._apiService.get(this.doctorCorrespondenceUrl.getDoctorCorrespondenceById + id, true).pipe(
        map((response: any) => {
        return this.returnResponse(response);
      }));
  }

  saveDoctorCorrespondence(doctorCorrespondence: DoctorCorrespondence): Observable<DoctorCorrespondence> {
    return this._apiService.post(this.doctorCorrespondenceUrl.saveDoctorCorrespondence, doctorCorrespondence, true, true).pipe(
        map((response: any) => {
        return this.returnResponse(response);
      }));
  }

  updateDoctorCorrespondence(id: number, doctorCorrespondence: DoctorCorrespondence): Observable<DoctorCorrespondence> {
    return this._apiService.put(this.doctorCorrespondenceUrl.updateDoctorCorrespondence + id, doctorCorrespondence, true, true).pipe(
        map((response: any) => {
        return this.returnResponse(response);
      }));
  }
}
